import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import TopbarClient from './TopbarClient';

export default function Topbar() {
  return (
    <header className="sticky top-0 z-40 w-full bg-card border-b border-border card-shadow">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center justify-between gap-4">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2.5 shrink-0">
          <AppLogo size={38} />
          <span className="font-extrabold text-xl text-foreground tracking-tight">
            Tolettu<span className="text-primary">.com</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          <Link
            href="/"
            className="px-4 py-2 rounded-xl text-sm font-semibold text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150"
          >
            Browse Listings
          </Link>
          <Link
            href="/owner-dashboard"
            className="px-4 py-2 rounded-xl text-sm font-semibold text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150"
          >
            Owner Dashboard
          </Link>
          <Link
            href="/contact"
            className="px-4 py-2 rounded-xl text-sm font-semibold text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-150"
          >
            Contact Us
          </Link>
        </nav>

        {/* Right Actions */}
        <TopbarClient />
      </div>
    </header>
  );
}